import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import {
  ApplicationDialogService,
  createTwoDecimalInputMask, findInvalidControlsRecursive,
  formControlErrorKeys,
  formControlErrorMessage,
  getUser,
  noSpaceValidator,
  WhitelabelSelectionComponent,
} from '@portal-workspace/grow-ui-library';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {Observable, of, Subscription} from 'rxjs';
import {
  AbnComponentValue,
  AcnComponentValue, CustomerEntityTypeValueOptions,
  GetAllWhitelabelsFn,
  MobileValue,
  isInternalUser,
  OriginatorBusiness, OriginatorTypeValueOptions,
  UpdateOriginatorInput, WhitelabelSelectionValue
} from '@portal-workspace/grow-shared-library';
import { InputMaskModule } from '@ngneat/input-mask';
import { ActivatedRoute,Router } from '@angular/router';
import { AdminService } from '../../service/admin.service';
import { PortalHotToastService } from '@portal-workspace/grow-ui-library';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { OriginatorTypeValue } from '@portal-workspace/grow-shared-library';
import { OriginatorRelationshipValue } from '@portal-workspace/grow-shared-library';
import { CustomerEntityTypeValue } from '@portal-workspace/grow-shared-library';
import { GetFn as RatecardGetFn, } from '@portal-workspace/grow-ui-library';
import { RateCardListValue } from '@portal-workspace/grow-shared-library';
import { switchMap, tap } from 'rxjs/operators';
import {createAsyncState, createAsyncStore, loadingFor} from '@ngneat/loadoff';
import { navigationUrlForCompanies } from '../../service/navigation-urls';
import { MatButtonModule } from '@angular/material/button';
import { RateCardListComponent } from '@portal-workspace/grow-ui-library';
import { MobileComponent } from '@portal-workspace/grow-ui-library';
import { AcnComponent } from '@portal-workspace/grow-ui-library';
import { AbnComponent } from '@portal-workspace/grow-ui-library';
import { CustomerEntityTypeComponent } from '@portal-workspace/grow-ui-library';
import { OriginatorRelationshipComponent } from '@portal-workspace/grow-ui-library';
import { DisableControlDirective } from '@portal-workspace/grow-ui-library';
import { OriginatorTypeComponent } from '@portal-workspace/grow-ui-library';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import {AsyncPipe, JsonPipe} from '@angular/common';
import {FlexModule} from "@angular/flex-layout";
import {WhitelabelService} from "../../service/whitelabel.service";


@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
    templateUrl: './company.page.html',
    styleUrls: ['./company.page.scss'],
    standalone: true,
    imports: [
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    OriginatorTypeComponent,
    DisableControlDirective,
    FormsModule,
    ReactiveFormsModule,
    OriginatorRelationshipComponent,
    CustomerEntityTypeComponent,
    AbnComponent,
    AcnComponent,
    MobileComponent,
    RateCardListComponent,
    MatButtonModule,
    AsyncPipe,
    FlexModule,
    InputMaskModule,
    WhitelabelSelectionComponent,
    JsonPipe,
]
})
export class CompanyPage implements OnInit {
  loader = loadingFor('update', 'loading');
  store = createAsyncStore();
  errorTitle =  'Error Occurred!'
  errorMessage = 'Please try again.'
  retry(){
    this.reload();
  }
  errorKeys = formControlErrorKeys;
  errorMessages = formControlErrorMessage;
  createTwoDecimalInputMask = createTwoDecimalInputMask;
  originatorBusiness: OriginatorBusiness | null = null

  subscriptions: Subscription[] = [];

  formGroup: FormGroup<{
    type: FormControl<OriginatorTypeValue>,
    relationship: FormControl<OriginatorRelationshipValue>,
    entityName: FormControl<string | null>,
    entityType: FormControl<CustomerEntityTypeValue>,
    abn: FormControl<AbnComponentValue>,
    acn: FormControl<AcnComponentValue>,
    // aggregator: FormControl<AggregatorListValue>,
    website: FormControl<string | null>,
    email: FormControl<string | null>,
    telephoneNumber: FormControl<MobileValue>,
    ratecard: FormControl<RateCardListValue>,
    percentagePaid: FormControl<number | null>,
    whitelabelSelection: FormControl<WhitelabelSelectionValue>,
    remittanceEmail: FormControl<string | null>,
  }>;
  formControlType: FormControl<OriginatorTypeValue>;
  formControlRelationship: FormControl<OriginatorRelationshipValue>;
  formControlEntityName: FormControl<string | null>;
  formControlEntityType: FormControl<CustomerEntityTypeValue>;
  formControlAbn: FormControl<AbnComponentValue>;
  formControlAcn: FormControl<AcnComponentValue>;
  formControlWebsite: FormControl<string | null>;
  formControlEmail: FormControl<string | null>;
  formControlTelephoneNumber: FormControl<MobileValue>;
  formControlRatecard: FormControl<RateCardListValue>;
  formControlPercentagePaid: FormControl<number | null>;
  formControlWhitelabelSelection: FormControl<WhitelabelSelectionValue>;
  formControlRemittanceEmail: FormControl<string | null>;
  ratecardGetFn: RatecardGetFn;
  getAllWhitelabelsFn: GetAllWhitelabelsFn;

  constructor(private activatedRoute: ActivatedRoute,
              private adminService: AdminService,
              private toastService: PortalHotToastService,
              private whitelabelService: WhitelabelService,
              private router: Router,
              private formBuilder: FormBuilder,
              private cdr: ChangeDetectorRef,
              private dialogService: ApplicationDialogService) {
    this.formControlType = formBuilder.control(null, [Validators.required]);
    this.formControlRelationship = formBuilder.control(null, [Validators.required]);
    this.formControlEntityName = formBuilder.control(null, [Validators.required, noSpaceValidator()]);
    this.formControlEntityType = formBuilder.control(null, [Validators.required]);
    this.formControlAbn = formBuilder.control(null, [Validators.required]);
    this.formControlAcn = formBuilder.control(null, [Validators.required]);
    this.formControlWebsite = formBuilder.control(null, [Validators.required,Validators.pattern('((http|https)://)(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)')]);
    this.formControlEmail = formBuilder.control(null);
    this.formControlTelephoneNumber = formBuilder.control(null, [Validators.required]);
    this.formControlRatecard = formBuilder.control(null, [Validators.required, this.checkRateCardHasName()]);
    this.formControlPercentagePaid = formBuilder.control(null, [Validators.required]);
    this.formControlWhitelabelSelection = formBuilder.control(null, []);
    this.formControlRemittanceEmail = formBuilder.control(null, [Validators.email]);
    this.formGroup = formBuilder.group({
      type: this.formControlType,
      relationship: this.formControlRelationship,
      entityName: this.formControlEntityName,
      entityType: this.formControlEntityType,
      abn: this.formControlAbn,
      acn: this.formControlAcn,
      // aggregator: this.formControlAggregator,
      website: this.formControlWebsite,
      email: this.formControlEmail,
      telephoneNumber: this.formControlTelephoneNumber,
      ratecard: this.formControlRatecard,
      percentagePaid: this.formControlPercentagePaid,
      whitelabelSelection: this.formControlWhitelabelSelection,
      remittanceEmail: this.formControlRemittanceEmail,
    });
    this.ratecardGetFn = this.adminService.RatecardsGetFn;
    this.getAllWhitelabelsFn = this.whitelabelService.getAllWhitelabelsFn;
  }


  ngOnInit(): void {
    setupUntilDestroy(this);
    this.originatorBusiness = (this.activatedRoute.snapshot.data as any).originatorBusiness;
    console.log('***** originatorBusiness', this.originatorBusiness, this.formControlType.disabled);
    this.populate();
    this.checkForValidationIssues();
  }

  populate() {
    if (this.originatorBusiness) {
      const a: OriginatorTypeValue = OriginatorTypeValueOptions.find(opt => opt.type == this.originatorBusiness?.Type) ?? null; // { type: this.originatorBusiness.Type, name: '' };
      this.formControlType.setValue(a);

      const b: OriginatorRelationshipValue = this.originatorBusiness.Relationship;
      this.formControlRelationship.setValue(b);

      this.formControlEntityName.setValue(this.originatorBusiness.EntityName);

      const c: CustomerEntityTypeValue = CustomerEntityTypeValueOptions.find(opt => opt?.type == this.originatorBusiness?.EntityType) ?? null; // { type: this.originatorBusiness.EntityType, name: '' };
      this.formControlEntityType.setValue(c);

      this.formControlAbn.setValue(this.originatorBusiness.ABN);
      this.formControlAcn.setValue(this.originatorBusiness.ACN);

      this.formControlWebsite.setValue(this.originatorBusiness.Website);
      this.formControlEmail.setValue(this.originatorBusiness.Email);
      this.formControlTelephoneNumber.setValue(this.originatorBusiness.TelephoneNumber);

      // populate ratecard once ready
      const rateCardId = this.originatorBusiness.RatecardId;
      if (rateCardId) {
        this.subscriptions.push(this.adminService.getRatecardDetails(rateCardId).pipe(
          this.loader.loading.track(),
        ).subscribe(resp => {
          if (resp.payload && resp.payload.length > 0) {
            const e: RateCardListValue = { RatecardId: rateCardId, Name: resp.payload[0].Name, CreateTime: resp.payload[0].CreateTime };
            this.formControlRatecard.setValue(e);
          }
        }));
      }

      this.formControlPercentagePaid.setValue(this.originatorBusiness.PercentagePaid);
      this.formControlRemittanceEmail.setValue(this.originatorBusiness.remittanceEmail ?? null);

      // populate whitelable, once ready
      const whitelabelId = this.originatorBusiness.whitelabelId;
      if (whitelabelId) {
        this.subscriptions.push(
          this.whitelabelService.getWhitelabelById(whitelabelId).pipe(
            this.loader.loading.track(),
          ).subscribe((e => {
            if (e.payload) {
              this.formControlWhitelabelSelection.setValue({id: e.payload.id, title: e.payload.title});
            }
          }))
        );
      }
    } else {
      this.store.value$ = of(createAsyncState({
        error: new Error(`Invalid orignator business`)
      }));
      this.toastService.publishErrorNotification({
        type: 'error',
        errorTitle: this.errorTitle,
        errorMessage: this.errorMessage,
        retryFn: this.retry.bind(this),
      });
    }
  }

  checkForValidationIssues() {
    Object.keys(this.formGroup.controls).forEach(field => {
      const control = this.formGroup.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
    this.cdr.detectChanges();
  }

  reload() {
    this.store = createAsyncStore();
    if (this.originatorBusiness) {
      this.adminService.getOriginatorById(this.originatorBusiness.OriginatorBusinessId).pipe(
        this.toastService.publishErrorNotificationObservable({
          errorTitle: this.errorTitle, errorMessage: this.errorMessage, retryFn: this.retry.bind(this),
        }),
        this.store.track(),
        tap(r => {
          this.originatorBusiness = r.payload
          this.populate();
        })
      ).subscribe();
    }
    else{
      this.store.value$ = of(createAsyncState({
        error: new Error(`Invalid orignator business`)
      }));
      this.toastService.publishErrorNotification({
        type: 'error',
        errorTitle: this.errorTitle,
        errorMessage: this.errorMessage,
        retryFn: this.retry.bind(this),
      });
    }
  }

  update($event: Event) {
    // NOTE: form controls should be valid at this point (pass validators validation)
    if (this.originatorBusiness) {
      const relationship: OriginatorRelationshipValue = this.formControlRelationship.value;
      const entityType: CustomerEntityTypeValue = this.formControlEntityType.value;
      if (entityType) {
        const ratecard: RateCardListValue = this.formControlRatecard.value;
        const input: UpdateOriginatorInput = {
          // Type: type!.type,
          Relationship: relationship,
          EntityName: this.formControlEntityName.value ?? '',
          EntityType: entityType.type,
          ABN: this.formControlAbn.value ?? '',
          ACN: this.formControlAcn.value ?? '',
          // Aggregator: aggregator!.aggregatorId,
          Website: this.formControlWebsite.value ?? '',
          Email: this.formControlEmail.value ?? '',
          TelephoneNumber: this.formControlTelephoneNumber.value ?? '',
          RatecardId: ratecard!.RatecardId,
          PercentagePaid: this.formControlPercentagePaid.value ?? 0,
          whitelabelId: this.formControlWhitelabelSelection?.value?.id ?? undefined,
        };
        console.log(`****** update originator`, input);
        this.subscriptions.push(this.saveOriginator(this.originatorBusiness.OriginatorBusinessId, input).pipe(
          this.loader.update.track(),
          this.toastService.retryableMessage({
            successMessage: 'Company details saved',
            errorMessage: 'Failed to save the Company details',
            retryFn: ()=> {
              console.log('**** retry ', this);
              this.update($event);
            }
          }),
          tap(r => {
            this.reload();
          })
        ).subscribe());
      } else {
        // this should not happen as there is a validator for entity type
        this.dialogService.openAlertDialog({message: `Alert`, subMessage: `Entity type is not valid`});
      }
    }
  }

  // Remittance email is aggregator-only and internal-only (the API enforces both).
  get showRemittanceEmail(): boolean {
    return this.originatorBusiness?.Type === 'aggregator' && isInternalUser(getUser());
  }

  private saveOriginator(originatorBusinessId: number, input: UpdateOriginatorInput): Observable<unknown> {
    const saveDetails$ = this.adminService.updateOriginatorBusiness(originatorBusinessId, input);
    if (!this.showRemittanceEmail) {
      return saveDetails$;
    }
    return saveDetails$.pipe(
      switchMap(() => this.adminService.updateAggregatorRemittanceEmail({
        originatorBusinessId,
        remittanceEmail: this.formControlRemittanceEmail.value?.trim() || null,
      })),
    );
  }

  async onClickBack() {
    await this.router.navigate(navigationUrlForCompanies())
  }

  checkRateCardHasName (): ValidatorFn { // Ratecard only has the name after loading the ratecard list
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      return !(val && val.Name && val.Name != '') ? {hasName: true} : null;
    }
  }

  findInvalidControlRecursive = findInvalidControlsRecursive;
}
